import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';

import { DialogService } from 'primeng/dynamicdialog';

import { currency } from 'app/constants/currency.constants';
import { HelperService, DataService, CalculationService, HTTPService } from 'app/services';

import { escapeRegExp } from 'lodash';
import { CurrencyPipe } from '@angular/common';

@Component({
  selector: 'app-tire-lookup-card',
  templateUrl: './tire-lookup-card.component.html',
  styleUrls: ['./tire-lookup-card.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TireLookupCardComponent implements OnInit {
  @Input() isOpenFromRO: boolean = false;
  @Input() isOpenFromQuickTireLookup: boolean = false;
  @Input() tire: any = {};
  @Input() selectedTireDetails: any = {};
  @Input() source: string = '';
  @Input() inventoryType: string = '';
  @Input() orderService: any = {};
  @Input() selectedTire: any = {};
  @Input() serviceSuggestions: any[] = [];
  @Input('services')
  set setServices(services: any[]) {
    if (services) {
      this._services = [...services];
      this.handleSearch(this.searchQuery);
    }
  }
  @Input() hideCost: boolean = false;
  @Input() selectedQty: number = 4;
  @Input() defaultServiceTotal: number = 0;
  @Input() selectedTax: any = {};
  @Input() selectedPricingMatrix: any = {};
  @Input() tireSettings: any = {};
  @Input() isOpenFromReplenishment: boolean = false;
  @Input() taxAmtOnAdonService: number = 0;
  @Input() fetValueSource: string = '';

  @Output() appHandleServiceCreate = new EventEmitter();
  @Output() appHandleServiceSelect = new EventEmitter();
  @Output() appHandleOpenLocationDialog = new EventEmitter();
  @Output() appHandleViewMore = new EventEmitter();
  @Output() appHandleCalculateTotal = new EventEmitter();
  @Output() appHandleTireConnectViewDetail = new EventEmitter();
  @Output() appHandleAlTireValidation = new EventEmitter();

  seasonLabel = {
    '': 'All season',
    summer: 'Summer',
    winter: 'Winter',
    all: 'All season',
  };
  seasonIcon = {
    '': 'fas fa-cloud-sun-rain font-primary',
    summer: 'fas fa-temperature-hot font-yellow',
    winter: 'fas fa-snowflakes font-blue-800',
    all: 'fas fa-cloud-sun-rain font-primary',
  };
  _services: any[] = [];
  searchQuery: string = '';
  usd: string = currency.USD;
  isDetailsVisible: boolean = false;
  isAdding: boolean = false;
  isQTQAddOnEnable: boolean = this.dataService.isQTQAddOnEnable;
  isMultiLocationEnabled: boolean = false;
  isPassThroughTaxEnable: boolean = this.dataService.isPassThroughTaxEnable;
  localFetValue: number = 0;

  isLoading: boolean = false;
  tireConnectFetSouceValues: any = {
    tireconnect: '(Estimated)',
    '': '(Supplier provided)',
  };

  constructor(
    private helperService: HelperService,
    private dialogService: DialogService,
    private dataService: DataService,
    private currencyPipe: CurrencyPipe,
    private calculationService: CalculationService,
    private httpService: HTTPService,
  ) {}

  ngOnInit() {
    if (this.isOpenFromReplenishment) {
      this.isQTQAddOnEnable = false;
    }
    this.isMultiLocationEnabled = this.helperService.getCompany().isMultiLocationEnabled;
    this.localFetValue = this.tire?.localFetValue || 0;
    this.calculateSaleTaxOnTirePrice();
    if (this.dataService.isAttributeBasedPricingEnable) {
      this.applyMatrix();
    }
  }

  calculateSaleTaxOnTirePrice() {
    if (Object.keys(this.selectedTax || {})?.length) {
      if (this.selectedTax?.taxRates?.length) {
        const taxCalculated = this.calculationService.calculateOrderItemTaxes({
          total: this.tire?.price || 0,
          taxRates: this.selectedTax?.taxRates,
          roundOffTax: false,
        });
        this.tire.tireSalesTaxAmt = taxCalculated?.taxAmt;
        // const taxOnAdOnService = this.calculationService.calculateOrderItemTaxes({
        //   total: this.defaultServiceTotal || 0,
        //   taxRates: this.selectedTax?.taxRates,
        //   roundOffTax: false
        // });
        // this.tire.adOnServiceSalesTaxAmt = taxOnAdOnService.taxAmt;
      } else {
        this.tire.tireSalesTaxAmt = 0;
        //this.tire.adOnServiceSalesTaxAmt = 0;
      }
    } else {
      this.tire.tireSalesTaxAmt = 0;
      //this.tire.adOnServiceSalesTaxAmt = 0;
    }
  }

  applyMatrix() {
    try {
      if (Object.keys(this.selectedPricingMatrix || {})?.length) {
        if(this.tireSettings?.tire?.pricingRule?.length) {
          this.selectedPricingMatrix = this.tireSettings?.tire?.pricingRule?.filter((rule) => rule.type === (this.selectedPricingMatrix?.value || this.selectedPricingMatrix?.type));
        } else {
          this.selectedPricingMatrix = [];
        }
        
        if (this.selectedPricingMatrix?.length) {
          this.tire.price = this.calculationService.calculateMarkUpUsingPricing(this.tire.cost, this.selectedPricingMatrix[0]?.defaultMatrix);
        } else {
          this.tire.price = this.calculationService.calculateMarkUpUsingPricing(this.tire.cost, this.tireSettings?.tire?.pricing);
        }
      }
    } catch (error) {
      console.error('Error in applyMatrix', error);
    }
  }
  handleCountChange(count: number = 0) {
    this.tire.count = Number(count || 0);
    this.appHandleCalculateTotal.emit();
  }

  handleSearch(query: string = '') {
    this.searchQuery = query;

    if (!query) {
      this.serviceSuggestions = this.helperService.deepCopy(this._services);
    } else {
      this.serviceSuggestions = this._services.filter(({ title }) => new RegExp(escapeRegExp(query), 'ig').test(title));
    }
  }

  getTaxBreakDownTooltip(fetRate: number, tireSalesTaxAmt: number): string {
    const total: number = this.calculationService.roundOff(fetRate * this.selectedQty + tireSalesTaxAmt);
    let tooltip: string = `
      <div class="flex-column p-2">
        <div class="flex-column gap-1">
          <div class="flex-between-center">
            <span>FET</span>
            <span>${this.currencyPipe.transform(fetRate * this.selectedQty, this.usd)}</span>
          </div>
          <div class="flex-between-center">
            <span>${'Sales Tax (' + this.selectedTax?.name + ')' || ''}</span>
            <span>${this.currencyPipe.transform(tireSalesTaxAmt, this.usd)}</span>
          </div>
          <div class="flex-between-center border-top mt-2 pt-1">
            <span>Total tax</span>
            <span>${this.currencyPipe.transform(total, this.usd)}</span>
          </div>
        </div>
      </div>
    `;
    return tooltip;
  }

  getFETFromTireConnect(tire: any) {
    let partNumber: string = '';
    if (this.source === 'autoleap') {
      partNumber = tire?.tireExternalId;
    } else if (this.source === 'tireconnect') {
      partNumber = tire?.partNumber;
    } else {
      partNumber = tire?.numericItemId;
    }
    if (this.fetValueSource === 'local' && tire?.tireconnectFetValue >= 0) {
      tire.fetValue = tire?.tireconnectFetValue;
      this.fetValueSource = 'tireconnect';
    } else if (this.fetValueSource === 'tireconnect' && this.localFetValue >= 0) {
      tire.fetValue = this.localFetValue || 0;
      this.fetValueSource = 'local';
    }
    if (!partNumber) {
      return;
    }

    if (tire?.tireconnectFetValue) {
      return;
    }
    const dataObj = {
      partNumbers: [partNumber],
      season: null,
      categories: [],
      suppliers: [],
      offers: [],
    };
    this.isLoading = true;
    this.httpService
      .getFETFromTireConnect(dataObj)
      .then(
        (res: any) => {
          if (res?.data?.tires?.length) {
            tire.tireconnectFetValue = res?.data?.tires[0].fet || 0;
            tire.tireconnectFetSource = res?.data?.tires[0]?.fet_source || '';
            if (tire?.tireconnectFetValue) {
              tire.fetValue = tire?.tireconnectFetValue;
              this.fetValueSource = 'tireconnect';
            }
            tire.category = res?.data?.tires[0]?.category || '';
            tire.tireType = res?.data?.tires[0]?.tire_type || '';
          } else {
            this.helperService.showToaster('error', res?.notice);
          }
        },
        (err) => {
          this.helperService.showToaster('error', err);
        },
      )
      .finally(() => {
        this.isLoading = false;
      });
  }

  getFETTooltip(tireConnectFET: number, localFET: number, FETInuse: string, tireconnectFetSource: string): string {
    let tooltip: string = '';
    if (FETInuse === 'tireconnect') {
      tooltip = `
      <div class="flex-column p-2">
        <div class="flex-column mb-3">
          <span>TireConnect FET: <b>${this.currencyPipe.transform(tireConnectFET, this.usd)}</b> ${tireConnectFET ? this.tireConnectFetSouceValues[tireconnectFetSource] : ''}</span>
          <span>Local FET: <b>${this.currencyPipe.transform(localFET, this.usd)}</b></span>
        </div>
        <div class="flex-row">Click to use Local FET</div>
      </div>
    `;
    } else {
      tooltip = `
      <div class="flex-column p-2">
        <div class="flex-column mb-3">
          <span>Local FET: <b>${this.currencyPipe.transform(localFET, this.usd)}</b></span>
          <span>TireConnect FET: <b>${this.currencyPipe.transform(tireConnectFET, this.usd)}</b> ${tireConnectFET ? this.tireConnectFetSouceValues[tireconnectFetSource] : ''}</span>
        </div>
        <div class="flex-row">Click to use TireConnect FET</div>
      </div>
    `;
    }

    return tooltip;
  }

  handleServiceCreate({ name }: any) {
    const service = this.helperService.deepCopy(this.orderService) || {};

    service.title = name;
    service.serviceTempId = new Date().getTime();

    setTimeout(() => {
      this.handleSelectService({ ...service });
    }, 200);
    this.handleSearch(this.searchQuery);

    this._services.push(service);
  }

  handleSelectService(service: any) {
    this.selectedTire.service = service;
    this.appHandleServiceCreate.emit(this._services);
  }

  handleSelectTire(tire: any) {
    this.isAdding = true;

    if (this.isOpenFromQuickTireLookup && this.source === 'autoleap') {
      if (!this.handleTireValidation(tire)) {
        this.isAdding = false;
        return;
      }
    }

    setTimeout(() => {
      this.isAdding = false;
      this.appHandleServiceSelect.emit(tire);
    }, 800);
  }

  handleViewMore() {
    this.isDetailsVisible = !this.isDetailsVisible;
    this.appHandleViewMore.emit(this.isDetailsVisible);
  }

  handleOpenLocationDialog(tire: any) {
    this.appHandleOpenLocationDialog.emit(tire);
  }

  handleViewDetails(tire: any) {
    this.appHandleTireConnectViewDetail.emit(tire);
  }

  handleBlur(tire: any) {
    this.handleTireValidation(tire);
    this.appHandleAlTireValidation.emit(tire);
  }

  handleFocus(tire: any) {
    tire.error = false;
  }

  handleTireValidation(tire: any) {
    if (tire === null) {
      return false;
    }

    if (tire.countAvailable < tire.count) {
      tire.error = true;
      this.helperService.showToaster('error', `Qty can't be greater than available qty`);
      return false;
    }
    return true;
  }
}
